import axios from '../../axios/axios';
import ipAddress from '../../axios/ipAddress' //域名
import QS from 'qs'; //序列化

/**
 * 用户相关接口
 */
const user = {

    /**
     * 登陆相关
     */

     //登陆
   //   login(user){
   //      return axios.post(ipAddress.qi+'/admin/a1/login',user,true)
   //   },

     //选择角色类型
   //   option(){
   //      return axios.post(ipAddress.qi+'/admin/a1/admin/getRole',null,false)
   //   },

     //获取导航栏
   //   selectNav(id){
   //    return axios.post(ipAddress.qi+'/admin/a1/admin/getResource',QS.stringify({
   //       id:id
   //    }),false)
   //   }

      /**
       * 管理系统
       */
      login(user){
         return axios.post(ipAddress.qi+'/admin/a1/login',user,true)
      },

      /**
       * 验证
       */
      loginType(tel){
        return axios.post(ipAddress.qi+'/admin/a1/getLoginInfo',QS.stringify({
          tel:tel
        }),false)
      },

      //发送验证码
      loginAuth(tel){
        return axios.post(ipAddress.qi+'/admin/a1/commons/sendSms',QS.stringify({
          telNumber:tel
        }),false)
      },
}
export default user;


// WEBPACK FOOTER //
// ./src/js/user/user.js